import React, {FC, useEffect, useState} from 'react'
import {CustomModal} from '../../partials/modals/CustomModal'
import {Button} from '@mui/material'
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined'
import {InputField} from '../../../app/components'
import {apiGetConfigMultiLanguage, useLang} from '../../i18n/Metronici18n'
import {
  creatOrUpdateMultiLanguageApplication,
  getListValueOfKey,
  messageError,
} from '../../../app/utils'
import * as component from '../../../app/components/redux/componentRedux'
import {useDispatch} from 'react-redux'

type Props = {
  show: boolean
  handleCloseModal: (close: boolean) => void
  content?: string
}

const ModalMultiLanguage: FC<Props> = ({show, handleCloseModal, content}) => {
  const [defaultValue, setDefaultValue] = useState(content)
  const [vietnamese, setVietnamese] = useState('')
  const [japanese, setJapanese] = useState('')
  const [english, setEnglish] = useState('')
  const dispatch = useDispatch()
  const lang = useLang()

  const handleChangeDefaultValue = (data: string) => {
    setDefaultValue(data)
  }

  const handleChangeVietNamValue = (data: string) => {
    setVietnamese(data)
  }

  const handleChangeEnglishValue = (data: string) => {
    setEnglish(data)
  }

  const handleChangeJapanValue = (data: string) => {
    setJapanese(data)
  }

  const handleAddNew = () => {
    let model = [
      {
        languageCode: 'VI',
        applicationType: 2,
        key: defaultValue,
        value: vietnamese.trim(),
      },
      {
        languageCode: 'EN',
        applicationType: 2,
        key: defaultValue,
        value: english ? english.trim() : vietnamese.trim(),
      },
      {
        languageCode: 'JP',
        applicationType: 2,
        key: defaultValue,
        value: japanese ? japanese.trim() : vietnamese.trim(),
      },
    ]
    dispatch(component.actions.showBackdrop({show: true}))
    creatOrUpdateMultiLanguageApplication(model)
      .then((res: any) => {
        if (res && !res.isError) {
          apiGetConfigMultiLanguage(lang.toLocaleUpperCase(), '2')
          setVietnamese('')
          setJapanese('')
          setEnglish('')
          handleCloseModal(false)
          dispatch(component.actions.showBackdrop({show: false}))
          dispatch(
            component.actions.writeAlert({
              show: true,
              type: 'success',
              message: res.message,
            })
          )
        }
      })
      .catch((error) => {
        dispatch(component.actions.showBackdrop({show: false}))
        dispatch(
          component.actions.writeAlert({
            show: true,
            type: 'success',
            message: messageError(error.response),
          })
        )
      })
  }

  const ModalBtn = () => (
    <>
      <Button onClick={handleAddNew} size='small' variant='outlined' className='modal-footer-btn'>
        <AddBoxOutlinedIcon />
        Lưu
      </Button>
    </>
  )

  useEffect(() => {
    if (!content) return
    getListValueOfKey(content, '2').then((res: any) => {
      if (res && !res.isError) {
        if (res.result.length > 0) {
          setVietnamese(res.result.find((o: any) => o.languageCode == 'VI')?.value)
          setJapanese(res.result.find((o: any) => o.languageCode == 'JP')?.value)
          setEnglish(res.result.find((o: any) => o.languageCode == 'EN')?.value)
        } else {
          switch (lang) {
            case 'vi':
              setVietnamese(content)
              break
            case 'en':
              setEnglish(content)
              break
            case 'jp':
              setJapanese(content)
              break
            default:
              setVietnamese(content)
              break
          }
        }
      }
    })
  }, [content])

  return (
    <>
      <CustomModal
        open={show}
        handleCloseModal={(close) => handleCloseModal(close)}
        widthModal='60%'
        modalTitle={'Cấu hình đa ngôn ngữ: ' + content}
        ModalBtn={ModalBtn}
      >
        <div>
          <InputField
            label='Nội dung'
            id='defaltValue'
            name='defaltValue'
            placehoder='Nhập Nội dung'
            inputValue={defaultValue}
            handleBlurInput={handleChangeDefaultValue}
          />
          <InputField
            label='Tiếng Việt'
            id='viet'
            name='viet'
            placehoder='Nhập Tiếng Việt'
            inputValue={vietnamese}
            handleBlurInput={handleChangeVietNamValue}
          />
          <InputField
            label='Tiếng Anh'
            id='english'
            name='english'
            placehoder='Nhập Tiếng Anh'
            inputValue={english}
            handleBlurInput={handleChangeEnglishValue}
          />
          <InputField
            label='Tiếng Nhật'
            id='japan'
            name='japan'
            placehoder='Nhập Tiếng Nhật'
            inputValue={japanese}
            handleBlurInput={handleChangeJapanValue}
          />
        </div>
      </CustomModal>
    </>
  )
}

export {ModalMultiLanguage}
